module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-container-80",
    staticStyle: {
      "overflow-y": "auto"
    },
    style: ({
      maxHeight: _vm.getMaxHeightClient() + 'px'
    }),
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body m-0"
  }, [_c('devis-form', {
    attrs: {
      "buyer": _vm.devisFormData.buyer,
      "propsDateExec": _vm.devisFormData.dateExec,
      "propsSellerIBAN": _vm.devisFormData.sellerIBAN
    }
  })], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a571402", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a571402","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/popups/attachments/CMAttachmentsDevisForm.vue
// module id = 2302
// module chunks = 2